export default {
  load (name, defValue) {
    let value = window.localStorage.getItem(name)
    if (value) {
      return JSON.parse(value)
    } else {
      return defValue
    }
  },
  save (name, value) {
    window.localStorage.setItem(name, JSON.stringify(value))
  }
}



// WEBPACK FOOTER //
// ./src/util/cache.js